/*
 * File: DiagnosisSearch.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays the search page for the post charge dx search
 */
import React from "react";
import SearchFormInput from "./SearchFormInput";
import SearchResults from "./SearchResults";
import PropTypes from "prop-types";
import UISearchStore from "services/patients/post_charges/store/UISearchStore";
import { useStore } from "utils/useStore";
import { observer } from "mobx-react";

const DiagnosisSearch = ({ selectedDiagnosesStore, parentCallBack }) => {
  const uiSearchStore = useStore(UISearchStore);

  const handleChange = keyword => {
    uiSearchStore.setDiagnosisKeyword(keyword);
  };

  const handleSearch = () => {
    uiSearchStore.searchDiagnoses();
  };

  const handleResultClick = result => {
    selectedDiagnosesStore.addFormDiagnosis(
      result.code,
      result.diagnosis,
      result.umlsId
    );
    uiSearchStore.clearDiagnosisSearch();
    parentCallBack();
  };

  const actions = {
    handleChange,
    handleSearch,
    handleResultClick
  };

  return (
    <React.Fragment>
      <SearchFormInput data={uiSearchStore} actions={actions} />
      <SearchResults
        data={uiSearchStore}
        handleResultClick={handleResultClick}
        selectedDiagnosesStore={selectedDiagnosesStore}
      />
    </React.Fragment>
  );
};

DiagnosisSearch.propTypes = {
  selectedDiagnosesStore: PropTypes.object.isRequired,
  parentCallBack: PropTypes.func.isRequired
};

export default observer(DiagnosisSearch);
